import React from "react";
import Table from "./SubAdminProfileTable";

const Profile = () => {
  return (
    <>
      <div >
        <Table />
      </div>
    </>
  );
};

export default Profile;
